import { inject, observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { LocalizedText } from '@shared-ui/localization-context';
import { LodgingQueryParamsProvider } from '@shared-ui/search-tools-lodging';
import { PrebundledPackagesSearchEntry } from '@shared-ui/retail-multi-item-prebundled-packages-search-entry';
import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkSpacing } from 'uitk-react-spacing';

import {
  IncentivesCollectionCarouselWrapper,
  IncentivesCollectionCarouselWrapperProps,
} from 'components/search/shared-ui/shared-ui-incentives-collection-carousel';
import { MesoFooter } from '../../meso/meso-footer';
import { PropertySearchListings } from '../property-search-listings/property-search-listings';

interface ResultsProps {
  searchResults?: SearchResultsStore;
  errorMessage: React.ReactElement;
  similarDestinationProps: IncentivesCollectionCarouselWrapperProps | null;
}

export const Results = inject('searchResults')(
  observer(({ searchResults, errorMessage, similarDestinationProps }: ResultsProps) => {
    const shoppingContextMultiItemId = searchResults?.shoppingContextMultiItemId;

    return (
      <>
        {!searchResults?.isError && shoppingContextMultiItemId && (
          <>
            <PrebundledPackagesSearchEntry inputs={{ sessionId: shoppingContextMultiItemId }} />
          </>
        )}
        <h2 className="is-visually-hidden">
          <LocalizedText message="hotels.search.results.heading" />
        </h2>
        <LodgingQueryParamsProvider urlSearchParams={new URLSearchParams(useLocation().search)}>
          <PropertySearchListings />
        </LodgingQueryParamsProvider>
        {errorMessage}
        {similarDestinationProps && <IncentivesCollectionCarouselWrapper {...similarDestinationProps} />}
        <MesoFooter />
        <ErrorBoundary label="voice-of-the-customer">
          <UitkSpacing margin={{ medium: { blockstart: 'six' } }}>
            <div data-stid="shared-ui-voice-of-the-customer">
              <VoiceOfTheCustomer inputs={{}} />
            </div>
          </UitkSpacing>
        </ErrorBoundary>
      </>
    );
  })
);
